// Namespace "flextime": flextime account
const flextime = {
  'flextime.title': 'Flextime account',
  'flextime.period': '{from} to {to}',
  'flextime.balance': 'Balance',
  'flextime.worked': 'Worked',
  'flextime.target': 'Target',
  'flextime.targetDetail': '{days} working days x {hours} h',
  'flextime.fzt': 'FZT deduction',
  'flextime.fztDetail': '{days} FZT days',
  'flextime.excluded': 'No target (vacation/sick leave): {days} days',
  'flextime.hint': 'Balance = worked hours − target. Each FZT day counts as minus hours equal to the daily target.',
  'flextime.hoursUnit': 'h',
  'flextime.error': 'Could not load flextime account.',
};

export default flextime;
